var map = {
	"./music-instructions.json": 4460,
	"./music-library-intro2024.json": 4461,
	"./music-library-launch2024.json": 4462,
	"./music-progression.json": 4463,
	"./startSourcesAdvanced.json": 4464,
	"./startSourcesSimple.json": 4465,
	"./startSourcesSimple2.json": 4466,
	"./startSourcesTracks.json": 4467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4239;